import { statusChangeEventActionTypes } from "../actions";
import { StatusChangeEventConstants } from "../constants";
import { statusChangeEventConfigState } from "../interfaces";

// Constants
/**
 * This defines the default state
 * for the AppConfig.
 */

const defaultState: statusChangeEventConfigState = {
  statusChangeEvent:null
};

//Functions
export const statusChangeEventReducer = (
  state: statusChangeEventConfigState = defaultState,
  action: statusChangeEventActionTypes
): statusChangeEventConfigState => {
  switch (action.type) {

    case StatusChangeEventConstants.GET_STATUS_CHANGE_EVENT_DATA:
      return {
        ...state,
        statusChangeEvent: action.payload
      };

    case StatusChangeEventConstants.CHANGE_OPTION:
      return {
        ...state,
        statusChangeEvent: action.payload
      };
    
    default:
      return state;
  }
};
